/**
 * 页面标题管理工具
 */

// 默认标题配置
const DEFAULT_TITLE = '青象传媒'

/**
 * 设置页面标题
 * @param {string} title - 页面标题
 */
export function setPageTitle(title) {
  document.title = title
}

/**
 * 获取当前页面标题
 * @returns {string} 当前页面标题
 */
export function getPageTitle() {
  return document.title
}

/**
 * 重置为默认标题
 */
export function resetToDefaultTitle() {
  document.title = DEFAULT_TITLE
}
